import templateUrl from './adp-number-assignment.component.html';
import { NewHireVM } from './employment-processing-models';
import { EventEmitter } from '../../common/components/event-emitter';

export const AdpNumberAssignmentComponent = {
    templateUrl,
    controllerAs: "vm",
    bindings: {
        fileName: "<",
        adpEmployeeNumbers: "<",
        handleCancel: "&",
        handleFinish: "&"
    },
    controller: class AdpNumberAssignmentComponent {
        fileName: string;
        adpEmployeeNumbers: NewHireVM[];
        handleCancel: EventEmitter<any>;
        handleFinish: EventEmitter<any>;
        pageNumber = 1;
        pageSize = 10;
        selectionCount() {
            return this.adpEmployeeNumbers.reduce(function (count, number) {
                return count + (number.isSelected ? 1 : 0);
            }, 0);
        }
    }
};
